import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { LinkField } from '@prismicio/client';
import { BrandService } from 'brand';
import { SvgComponent } from 'icon';
import { LinkComponent } from 'link';

export type Card = {
  id: string;
  icon: string;
  title: string[];
  description: string[];
  link: LinkField;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-action-card',
  imports: [CommonModule, LinkComponent, SvgComponent],
  templateUrl: './action-card.component.html',
})
export class ActionCardComponent {
  public brandService = inject(BrandService);
  @Input({ required: true }) public link: LinkField;
  @Input() public icon: string;
  @Input() public title: string;
  @Input() public description: string;
  @Input() public additionalClass = '';
}
